import ModalType from '@/Enums/Segments/ModalType.enum';
import type { ISegmentsFilterModel } from '@/Interfaces/Filters/FilterModel.interface';
import type { ISegmentFormData } from '@/Interfaces/Segments/Segment.interface';

export const modalTitle: Record<ModalType, string> = {
  [ModalType.NewSegment]: 'Create New Segment',
  [ModalType.ViewSegment]: 'View Segment',
};

export const defaultSegment: ISegmentFormData = {
  name: '',
  advertiser: null,
  creatives: [],
  segmentUrl: undefined,
};

export const defaultFilter: ISegmentsFilterModel = {
  whitelabels: [],
  clients: [],
  advertisers: [],
  active: true,
};
